
export const tallySync = (state): String => state.tallySync.operations;
export const tallyReachable = (state): Boolean => state.tallySync.tallyReachable;